// @flow

import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isAuthorized } from '../utils/TagManagerUtils';
import Analytics from '../utils/AnalyticsUtils';

const useAnalytics = () => {
  const history = useHistory();

  useEffect(() => {
    return history.listen((location) => {
      if (!isAuthorized()) return;

      Analytics.sendPageView(location.pathname);
    });
  }, [history]);
};

export default useAnalytics;
